// extracted by mini-css-extract-plugin
export default {"hideTooltip":"O_-z","fadeIn":"P_-z","delay":"Q_-z","recommendedSizeTooltip":"R_-z"};